import './product.css';

import { Button, Card, Col, Row, TextInput, Switch } from 'react-materialize';

import Config from '../../../config';
import FileService from '../../../services/file.service';
import MarcasRelacionadasView from './mrelacionados.view';
import ProductosRelacionadosView from './prelacionados.view';
import React from 'react';
import imageNotAvailable from './../../../assets/images/imagenotavailable.png';
import Loader from '../loader/loader.view';
import Swal from 'sweetalert2';

function includesNumber(colorid) {
  for (let i = 0; i < 10; i++) {
    if (colorid.includes(String(i))) {
      return true;
    }
  }
  return false;
}

class ProductView extends React.Component {
  // estado
  state = {
    productosRelacionados: null,
    marcasRelacionadas: null,
    isOpenMarcas: false,
    colores: [],
    filtredColors: [],
    colorBackTitulo: '#fff',
    colorText: null,
    imgBaseRute: Config.filesUrlEspeciales,
    productosTallas: [],
    loadTallasInventory: false,
    tallasPrecios: null,
    currentColor: '',
    canSetItem: false,
    showCodes: false
  };
  fileService = new FileService();

  async componentDidMount() {
    try {
      if ( this.props.product.modelosRelacionados )
      {
        this.props
          .getArticulosRelacionados(
            this.props.product.modelosRelacionados,
            this.props.product.cse_prod
          )
          .then((response) => {
            this.setState({ productosRelacionados: response });
          });
      }

      this.props.getMarcasRelacionadas(this.props.brandId).then((response) => {
        this.setState({ marcasRelacionadas: response });
      });
      await this.getColorPantone();

      this.setState({
        loadTallasInventory: true,
      });

      try {
        let color = this.state.colores[0].id;
        let tallasInventario = await this.props.getTallasExistencias(color);
        console.log(color, tallasInventario);
        this.colocarTallasPrecios(tallasInventario);
        this.state.colores[0].pulse = true;

        this.setState({
          productosTallas: tallasInventario,
          loadTallasInventory: false,
        });
      } catch (e) {
        Swal.fire({
          title: 'Error al traer las existencias',
          html: JSON.stringify(e)
        })
        console.log(e);
      }

      this.setState({
        marcasRelacionadas: [],
      });
    } catch (exception) {
      console.error(exception);
    }
  }

  componentDidUpdate() {
    // console.log(this.state);
  }

  getColorPantone() {
    this.setState({
      colores: this.props.colores,
      filtredColors : [...this.props.colores],
      currentColor: '',
    });
    //console.log("productos", this.props.productos);
    let colores = this.props.colores;
      if (colores.length === 0) {
      // regresando a vista de producto directo de la vista del pedido
      let coloresServicio = this.props.coloresServicio;
      let newColores = [];
      for (let i = 0; i < coloresServicio.length; i++) {
        for (let x = 0; x < this.props.productos.length; x++) {
          if (coloresServicio[i] === this.props.productos[x].color) {
            newColores.push({
              id: this.props.productos[x].color,
              name: this.props.productos[x].colorName,
              pantone: this.props.productos[x].pantone,
            });
            break;
          }
        }
      }
      colores = newColores;
    } else {
      // manejo de excepciones para mostrar codigo de color en circulos
      let desc_prod = this.props.product.desc_prod;
      let isExcept = false;
      let excepList = this.props.exceptColorNewMedList;

      for (let i = 0; i < excepList.length; i++) {
        if (excepList[i] === desc_prod) {
          isExcept = true;
        }
      }

      if (isExcept) {
        for (let i = 0; i < this.props.productos.length; i++) {
          if (this.props.productos[i].color === colores[i].id) {
            colores[i].id = this.props.productos[i].new_med;
          }
        }
      }
    }

    try {
      return new Promise(async (resolve) => {
        for (let i = 0; i < colores.length; i++)
        {
          let _pantones = null;
          let backColor = [];

          if (colores[i].pantone !== undefined)
          {
            if (colores[i].pantone.includes(','))
            {
              _pantones = colores[i].pantone.split(',');
              for (let z = 0; z < _pantones.length; z++)
              {
                let hexColor = this.props.pantones.filter((response) => {
                  return response.id?.toLowerCase() === _pantones[z].toLowerCase();
                });
                backColor = backColor.concat(hexColor);
              }
              let backLinear = 'linear-gradient(90deg, ';
              let backPorcent = 100 / backColor.length;
              for (let y = 0; y < backColor.length; y++) 
              {
                if (y === backColor.length - 1) {
                  backLinear =
                    backLinear +
                    backColor[y].hexadecimal +
                    ' ' +
                    backPorcent +
                    '%' +
                    ')';
                } else {
                  backLinear =
                    backLinear +
                    backColor[y].hexadecimal +
                    ' ' +
                    backPorcent +
                    '%' +
                    ',';
                }
              }
              backColor = backLinear;
              colores[i].hex = backColor;
            } 
            else
            {
              backColor = this.props.pantones.filter(
                (response) => response.id?.toLowerCase() === colores[i].pantone?.toLowerCase()
              );
              if (backColor.length === 1) {
                backColor = backColor[0].hexadecimal;
              } else {
                if (colores[i].pantone )
                {
                  console.error("Color no tiene pantone corregir!!");
                }
                let rutaImg = colores[i].id;
                if (rutaImg) {
                  backColor = `url('${this.props.url}COLORES/${rutaImg.toLowerCase().replaceAll(' ', '-')}.png') center center / 100% 100% no-repeat , url(${imageNotAvailable}) center center / 100% 100% no-repeat`;
                } else {
                  backColor = `url(${imageNotAvailable}) center center / 100% 100% no-repeat`;
                }
              }
              if (backColor === '#000') {
                this.setState({
                  colorBackTitulo: '#ccc',
                  colorTitulo: '#333',
                });
              }
              colores[i].hex = backColor;
            }
          }
        }
        this.setState({
          colores: colores,
          filtredColors: [...colores],
        });
        resolve(true);
      });
    } catch (e) {
      console.log(e);
    }
  }

  colocarSubtotal = (subtotal, color, talla, precio) => {
    let productosTallas = this.state.productosTallas;

    for (let i = 0; i < productosTallas.length; i++) {
      if (
        productosTallas[i].color === color &&
        productosTallas[i].talla === talla
      ) {
        productosTallas[i].prec_set = parseFloat(precio).toFixed(2);
        productosTallas[i].prec_prod = parseFloat(precio).toFixed(2);
        productosTallas[i].subtotal = parseFloat(subtotal).toFixed(2);
      }
    }

    this.setState({
      productosTallas: productosTallas,
    });
  };

  colocarTallasPrecios = (productosTallas) => {
    let tallasPrecios = [];
    let precios = [];

    for (let i = 0; i < productosTallas.length; i++) {
      precios.push(productosTallas[i].prec_prod);
    }
    precios = precios.filter(
      (value, index, self) => self.indexOf(value) === index
    );
    if (precios.length > 1) {
      for (let i = 0; i < precios.length; i++) {
        let productos = productosTallas.filter(
          (response) => response.prec_prod === precios[i]
        );
        if (productos.length > 1) {
          tallasPrecios.push({
            tallas: `${productos[0].talla}-${
              productos[productos.length - 1].talla
            }`,
            precio: precios[i],
          });
        } else {
          tallasPrecios.push({
            tallas: productos[0].talla,
            precio: precios[i],
          });
        }
      }
    }
    this.setState({
      tallasPrecios,
    });
  };

  actualizarProductosTallas = () => {
    const productosActualizados = [...this.state.productosTallas];

    const marcasCarrito = JSON.parse(localStorage.getItem("productosLocalStorage") || "[]");

    const cantidadesPorMarca = {};

    productosActualizados.forEach(producto => {
      const input = document.getElementById(`input-${producto.talla}-${producto.cve_prod}`);
      const cantidad = parseInt(input?.value || "0", 10);
      producto.cantidad = cantidad;

      const brandId = producto.brandId;
      if (!cantidadesPorMarca[brandId]) cantidadesPorMarca[brandId] = 0;
      cantidadesPorMarca[brandId] += cantidad;
    });

    marcasCarrito.forEach(producto => {
      const brandId = producto.brandId;
      const cantidad = parseInt(producto.cantidad || 0, 10);
      if (!cantidadesPorMarca[brandId]) cantidadesPorMarca[brandId] = 0;
      cantidadesPorMarca[brandId] += cantidad;
    });

    productosActualizados.forEach(producto => {
      const totalMarca = cantidadesPorMarca[producto.brandId] || 0;
      const usarMayoreo = totalMarca >= 12;

      const precioAplicado = this.props.getPriceByPriceListKey(
        usarMayoreo
          ? this.props.catalog.priceListType.MAYOREO
          : this.props.catalog.priceListType.MENUDEO,
        producto.priceList
      );

      const subtotal = producto.cantidad * precioAplicado;

      producto.precioAplicado = precioAplicado;
      producto.subtotal = subtotal;
      producto.prec_set = precioAplicado.toFixed(2);
      producto.priceListIdSet = usarMayoreo
        ? this.props.catalog.priceListType.MAYOREO
        : this.props.catalog.priceListType.MENUDEO;
    });

    this.setState({ productosTallas: productosActualizados });
  };

  actualizarProductos = () => {
    const productosActualizados = [...this.state.productosTallas];
    const tieredPricing = JSON.parse(localStorage.getItem("cat_tiered_pricing") || "[]");
    const marcasCarrito = JSON.parse(localStorage.getItem("productosLocalStorage") || "[]");

    const cantidadesPorMarcaCatColor = {};

    productosActualizados.forEach(producto => {
      const input = document.getElementById(`input-${producto.talla}-${producto.cve_prod}`);
      const cantidad = parseInt(input?.value || "0", 10);
      producto.cantidad = cantidad;

      const key = `${producto.brandId}_${producto.categoryId}_${producto.modeloId}_${producto.colorId || "null"}`;

      if (!cantidadesPorMarcaCatColor[key]) cantidadesPorMarcaCatColor[key] = 0;
      cantidadesPorMarcaCatColor[key] += cantidad;
    });

    marcasCarrito.forEach(producto => {
      const key = `${producto.brandId}_${producto.categoryId}_${producto.modeloId}_${producto.colorId || "null"}`;
      const cantidad = parseInt(producto.cantidad || 0, 10);
      if (!cantidadesPorMarcaCatColor[key]) cantidadesPorMarcaCatColor[key] = 0;
      cantidadesPorMarcaCatColor[key] += cantidad;
    });

    const promoControl = {};

    Object.keys(cantidadesPorMarcaCatColor).forEach(key => {
      const [brandId, categoryId, modeloId, colorId = "null"] = key.split("_");
      const promo = tieredPricing.find(item =>
      (
        item.ListId === brandId &&
        item.categoryId === categoryId &&
        item.typeList === "3"
      )
      ||
      (
        item.ListId === modeloId &&
        item.typeList === "2"
      )
    );

      if (promo) {
        let coloresValidos = [];
        const hasColorRestriccion = promo.colorId && promo.colorId.trim() !== "";

        if (hasColorRestriccion) {
          coloresValidos = promo.colorId.split(",").map(id => id.trim());
          if (!coloresValidos.includes(colorId)) return; 
        }

        const totalCantidad = cantidadesPorMarcaCatColor[key];
        const rango = promo.Range.find(r => r.multiple !== 0);

        if (rango) {
          const multiple = parseInt(rango.multiple);
          const unidadesConPromo = Math.floor(totalCantidad / multiple) * multiple;

          promoControl[key] = {
            precioPaquete: parseFloat(rango.price),
            multiple,
            unidadesConPromo
          };
        }
      }
    });

    productosActualizados.forEach(producto => {
      const key = `${producto.brandId}_${producto.categoryId}_${producto.modeloId}_${producto.colorId || "null"}`;

      const promo = promoControl[key];
      const cantidad = producto.cantidad;
      const precioBase = parseFloat(producto.priceList?.[0]?.price || "0");

      if (promo && cantidad > 0 && promo.unidadesConPromo > 0) {
        const { precioPaquete, multiple } = promo;
        const precioUnitarioPromo = precioPaquete / multiple;

        const enPromo = Math.min(cantidad, promo.unidadesConPromo);
        const normales = cantidad - enPromo;

        const subtotalPromo = enPromo * precioUnitarioPromo;
        const subtotalNormal = normales * precioBase;
        const subtotalFinal = subtotalPromo + subtotalNormal;

        const precioUnitarioFinal = subtotalFinal / cantidad;
        /*
        console.log('cantidad',cantidad,
          'precioBase',precioBase,
          'subtotalPromo',subtotalPromo,
          'subtotalNormal',subtotalNormal,
          'subtotalFinal',subtotalFinal,


        );
        */

        producto.precioAplicado = precioUnitarioFinal;
        producto.subtotal = subtotalFinal.toFixed(2);
        producto.prec_set = precioUnitarioFinal.toFixed(2);
        producto.prec_prod = precioUnitarioFinal.toFixed(2);
        producto.priceListIdSet = "escalonado";

        promo.unidadesConPromo -= enPromo;
      } else {
        const baseKey = `${producto.brandId}_${producto.categoryId}_${producto.modeloId}_${producto.colorId || "null"}`;

        const totalCantidad = cantidadesPorMarcaCatColor[baseKey] || 0;
        const usarMayoreo = totalCantidad >= 12;

        const precioAplicado = this.props.getPriceByPriceListKey(
          usarMayoreo
            ? this.props.catalog.priceListType.MAYOREO
            : this.props.catalog.priceListType.MENUDEO,
          producto.priceList
        );

        producto.precioAplicado = precioAplicado;
        producto.prec_set = precioAplicado.toFixed(2);
        producto.prec_prod = precioAplicado.toFixed(2);
        producto.priceListIdSet = usarMayoreo
          ? this.props.catalog.priceListType.MAYOREO
          : this.props.catalog.priceListType.MENUDEO;
      }
    });

    this.setState({ productosTallas: productosActualizados });
  };




  render() {
    //console.log(this.props.image);
    return (
      <Row>
        <Col xl={12} l={12} m={12} s={12}>
          <Col xl={12} l={12} m={12} s={12}>
            <Card
              id="leo"
              horizontal
              header={
                <React.Fragment>
                  <Col xl={6} l={6} m={6} s={6}>
                    <Row>
                      <img
                        alt={this.props.cve_prod}
                        src={this.props.image}
                        width="100%"
                        height="auto"
                        style={{ maxHeight: '792px' }}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.onError = null;
                          currentTarget.src = imageNotAvailable;
                        }}
                      />
                    </Row>
                    <Row>
                      <Switch
                          id="showCodes"
                          onLabel={'Mostrar'}
                          offLabel={'Ocultar'}
                          checked={this.state.showCodes}
                          onChange={(e) => this.setState({ showCodes: e.target.checked}) }
                        />
                    </Row>
                    <Row>
                      <ProductosRelacionadosView
                        imageRute={this.props.imageRute}
                        changeImageRute={this.props.changeImageRute}
                        changeProductViewIds={this.props.changeProductViewIds}
                        onClickElement={this.props.onClickElement}
                        items={this.state.productosRelacionados}
                      />
                    </Row>
                  </Col>
                </React.Fragment>
              }
              actions={[
                <div className="center" key={1}>
                      <Button
                        onClick={(event) => {
                          let producto = [];
                          try {
                            let inputsTallas = document.getElementsByClassName('inputTalla');
                            
                            for (let i = 0; i < inputsTallas.length; i++) {
                              let inputData = String(inputsTallas[i].id).split('-');
                              let talla = inputData[1];
                              let productId = inputData[2];
                              let color = this.props.colorSeleccionado;
                              let cantidad = parseFloat(inputsTallas[i].value);
                              
                              if (isNaN(cantidad) || cantidad <= 0) continue;

                              let foundProductoTalla = this.state.productosTallas.find((response) => {
                                return response.cve_prod === productId;
                              });

                              if (!foundProductoTalla) continue;

                              const inventoryTotal = parseFloat(
                                foundProductoTalla.existencias.reduce(
                                  (a, b) => a + (b.stock ? Number(b.stock) : 0),
                                  0
                                )
                              );

                              if (color.includes('-')) {
                                color = color.split('-')[1].trim();
                              }

                              const modeloId = foundProductoTalla.modeloId;
                              const tieredPricing = JSON.parse(localStorage.getItem("cat_tiered_pricing")) || [];
                              const escalonado = tieredPricing.find(item => item.ListId === modeloId);
                              const brandId =  foundProductoTalla.brandId;
                              const categoryId =  foundProductoTalla.categoryId;
                              const colorIdActual =  foundProductoTalla.colorId;
                              const promocion = tieredPricing.find(item =>
                                item.ListId === brandId &&
                                item.categoryId === categoryId
                              );
                              let prec_set = 0;
                              let prec_prod = 0;
                              let priceListIdSet = null;


                              if (promocion) {

                                const { typeList, Range, colorId } = promocion;
                                const coloresValidos = promocion.colorId.split(",");

                                if (typeList === "3") {
                                if (colorId === "" || coloresValidos.includes(colorIdActual)) {
                                  const rango = Range.find(r => r.multiple !== 0);

                                  if (rango) {
                                    let precioPorPaquete = parseFloat(rango.price);
                                    let multiple = parseInt(rango.multiple);
                                    let precioBase = parseFloat(foundProductoTalla.priceList[0].price);

                                  
                                    let restanteTotal = cantidad % multiple;

                                  if (restanteTotal > 0) {
                                    let restanteIndividual = cantidad % multiple;
                                    let paquetesIndividual = Math.floor(cantidad / multiple);

                                    let totalPorPaquetes = paquetesIndividual * precioPorPaquete;
                                    let totalPorRestante = restanteIndividual * precioBase;
                                    let totalFinal = totalPorPaquetes + totalPorRestante;

                                    let precioAplicado = (totalFinal / cantidad).toFixed(2);
                                    prec_set = precioAplicado;
                                    prec_prod = precioAplicado;
                                    priceListIdSet = `múltiplo x${multiple} + base`;
                                  } else {
                                 
                                   

                                    let precioAplicado = (precioPorPaquete / multiple).toFixed(2);
                                    prec_set = precioAplicado;
                                    prec_prod = precioAplicado;
                                    priceListIdSet = `múltiplo x${multiple}`;
                                  }
                                  }
                                }
                              }

                              }else if (escalonado) {
                                const { typeList, Range } = escalonado;

                                if (typeList === "1") {
                                  const rango = Range.find(r =>
                                    cantidad >= r.limitLower && cantidad <= r.LimitUpper
                                  );
                                  if (rango) {
                                    prec_set = parseFloat(rango.price);
                                    prec_prod = parseFloat(rango.price).toFixed(2);
                                    priceListIdSet = "escalonado";
                                  }
                                } else if (typeList === "2") {
                                    console.log("aplica typelist2");
                                    const rango = Range.find(r => r.multiple !== 0);
                                    if (rango) {
                                      const precioPorPaquete = parseFloat(rango.price);
                                      const multiple = parseInt(rango.multiple);

                                      const paquetes = Math.floor(cantidad / multiple); 
                                      const restante = cantidad % multiple;           

                                      const totalPorPaquetes = paquetes * precioPorPaquete;

                                      let precioBase = 0;
                                      if (foundProductoTalla?.priceList?.[0]) {
                                        precioBase = parseFloat(foundProductoTalla.priceList[0].price);
                                      }

                                      const totalPorRestante = restante * precioBase;

                                      const totalFinal = totalPorPaquetes + totalPorRestante;

                                      prec_set = totalFinal;
                                      prec_prod = totalFinal.toFixed(2);
                                      priceListIdSet = `múltiplo x${multiple} + base`;
                                    }
                                }
                              } else {
                                if (foundProductoTalla.priceList && foundProductoTalla.priceList.length > 0) {
                                  const fallbackPrice = parseFloat(foundProductoTalla.priceList[0].price);
                                  prec_set = fallbackPrice;
                                  prec_prod = fallbackPrice.toFixed(2);
                                  priceListIdSet = foundProductoTalla.priceList[0].id;
                                }
                              }

                              console.log("cantidad",cantidad,"prec_prod",prec_prod)
                              producto.push({
                                cantidad,
                                color,
                                inventario: inventoryTotal,
                                priceList: foundProductoTalla.priceList || [],
                                cve_prod: productId,
                                talla,
                                prec_set,
                                prec_prod: parseFloat(prec_prod).toFixed(2),
                                priceListIdSet,
                                modeloId
                              });

                            }

                            producto = producto.filter((response) => response.cantidad > 0);

                            if (producto.length > 0) {
                              try {
                                for (let i = 0; i < producto.length; i++) {
                                  this.props.insertIntoLocalStorage(producto[i], true);
                                }
                              } catch (e) {
                                console.log("Error al agregar productos", e);
                              } finally {
                              
                                let inputsTallas = document.getElementsByClassName('inputTalla');
                                for (let i = 0; i < inputsTallas.length; i++) {
                                  inputsTallas[i].value = null;
                                }
                              }
                            } else {
                              Swal.fire({
                                icon: 'warning',
                                title: `Agregar al menos una cantidad`,
                                html: `<div><p>No se agregó ningún producto al carrito</p></div>`,
                              });
                            }
                          } catch (error) {
                            console.log("Error general", error);
                            Swal.fire({
                              icon: 'warning',
                              title: `Error al seleccionar cantidades`,
                              html: `<div><p>No se agregó ningún producto al carrito</p></div>`,
                            });
                          }
                        }}
                        disabled={!this.state.canSetItem}
                        large
                      >
                        Agregar a Pedido
                      </Button>
                </div>,
              ]}
              className="card-product"
              key={1}
            >
              <Col xl={12} l={12} m={12} s={12}>
                <Row>
                  <div className="product-header">
                    {/* <h6 className='center product-title'>{`${this.props.product.descripcion} - $${this.props.product.prec_prod}`}</h6> */}
                    <h6 className="center product-title" title={`${this.props.product.cve_prod}`}>{`${this.props.product.descripcion}`}</h6>
                    <p className="center">
                      {this.state.tallasPrecios &&
                        this.state.tallasPrecios.map((value, index) => {
                          return (
                            <React.Fragment key={index}>
                              {value.tallas}: {value.precio}&nbsp;&nbsp;
                            </React.Fragment>
                          );
                        })}
                    </p>
                  </div>
                </Row>
                <Row>
                  <Col xl={12} l={12} m={12} s={12}>
                    {
                      (this.state.loadTallasInventory)
                      ?
                        <Loader/>
                      :
                        <table style={{ margin: '0 auto' }}>
                          <thead style={{}}>
                            <tr>
                              <th>Talla</th>
                              {Object.keys(this.props.locationsAvailable).map(
                                (location) => {
                                  return <th key={location}>{location}</th>;
                                }
                              )}
                              <th>Cantidad</th>
                              <th>Subtotal</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.productosTallas.map((value, index) => {
                              let precio = this.props.getPriceByPriceListKey(
                                this.props.catalog.priceListType.MENUDEO,
                                value.priceList
                              );
                              const inventoryTotal = parseFloat(
                                value.existencias.reduce(
                                  (a, b) => a + (b.stock ? Number(b.stock) : 0),
                                  0
                                )
                              );
                              return (
                                <React.Fragment key={index}>
                                  <tr title={(value) ? value.cve_prod : '' }>
                                    <td >{value.talla} <div style={{"display":(this.state.showCodes)?"block":"none"}}>{value.cve_prod}</div></td>
                                    {value.existencias.map(({ stock }, index) => {
                                      return <td key={index}>{stock || 0}</td>;
                                    })}
                                  <td>
                                      {inventoryTotal > 0 ? (
                                        <TextInput
                                          className={'inputTalla'}
                                          id={`input-${value.talla}-${value.cve_prod}`}
                                          label="Cantidad"
                                          type="number"
                                          min={1}
                                          onChange={(event) => {

                                            let cantidad = parseInt(event.target.value);

                                            if (!isNaN(cantidad) && cantidad > 0) {
                                            let precioAplicado = parseFloat(precio);
                                            let precioMayoreo = this.props.getPriceByPriceListKey(
                                                  this.props.catalog.priceListType.MAYOREO,
                                                  value.priceList
                                            );
                                            
                                            const modelo = this.props.product?.modeloId;
                                            const brandId =  value.brandId;
                                            const categoryId =  value.categoryId;
                                            const colorIdActual =  value.colorId;
                                            const tieredPricing = JSON.parse(localStorage.getItem("cat_tiered_pricing")) || [];
                                            const marcasCarrito = JSON.parse(localStorage.getItem("productosLocalStorage") || "[]");
                                            const escalonado = tieredPricing.find(
                                              item => item.ListId === modelo && item.typeList !== "4"
                                            );
                                            const promocion = tieredPricing.find(item =>
                                                    item.ListId === brandId &&
                                                    item.categoryId === categoryId
                                                  );
                                            const inputs = document.getElementsByClassName('inputTalla');
                                            let cantidadesTotalesCarrito = 0;
                                            let cantidadesTotales = 0;
                                          
                                            let precioPorPaquete = 0;

                                            let totalCantidad = marcasCarrito.reduce((total, producto) => {
                                              const brandId = producto.brandId;
                                              const categoryId = producto.categoryId;
                                              const colorProducto = producto.color;

                                              const promocion = tieredPricing.find(item =>
                                                item.ListId === brandId &&
                                                item.categoryId === categoryId
                                              );

                                              if (!promocion) return total;

                                              if (!promocion.colorId || promocion.colorId.trim() === "") {
                                                return total + (parseInt(producto.cantidad) || 0);
                                              }

                                              const coloresPermitidos = promocion.colorId.split(",").map(c => c.trim());

                                              if (coloresPermitidos.includes(colorProducto)) {
                                                return total + (parseInt(producto.cantidad) || 0);
                                              }

                                              return total;
                                            }, 0);

                                            for (let i = 0; i < inputs.length; i++) {
                                              const inputVal = parseInt(inputs[i].value || "0", 10);
                                              totalCantidad += inputVal ;
                                            }
                                            if (promocion) { 

                                              const { typeList, Range, colorId } = promocion;
                                              const coloresValidos = promocion.colorId.split(",");

                                              if (typeList === "3") {

                                                if (colorId === "") {  
                                                  const rango = Range.find(r => r.multiple !== 0);
                                                  if (rango) {
                                                    precioPorPaquete = parseFloat(rango.price);
                                                    let multiple = parseInt(rango.multiple);
                                                    let precioBase = parseFloat(precio);
                                                    
                                               
                                                    let restanteTotal = totalCantidad % multiple;

                                                    if (restanteTotal > 0) {
                                                      let restanteIndividual = cantidad % multiple;
                                                      let paquetesIndividual = Math.floor(cantidad / multiple);

                                                      let totalPorPaquetes = paquetesIndividual * precioPorPaquete;
                                                      let totalPorRestante = restanteIndividual * precioBase;
                                                      let totalFinal = totalPorPaquetes + totalPorRestante;

                                                      precioAplicado = totalFinal / cantidad;

                                                    } else {
                                                      

                                                      precioAplicado = precioPorPaquete / multiple;
                                                    }
                                                  }
                                                    setTimeout(() => this.actualizarProductos(), 0);
                                                }else if (typeList === "3" && coloresValidos.includes(colorIdActual) ){
                                                     const rango = Range.find(r => r.multiple !== 0);
                                                  if (rango) {
                                                    precioPorPaquete = parseFloat(rango.price);
                                                    let multiple = parseInt(rango.multiple);
                                                    let precioBase = parseFloat(precio);

                                                    
                                                    let restanteTotal = totalCantidad % multiple;

                                                    if (restanteTotal > 0) {
  
                                                      let restanteIndividual = cantidad % multiple;
                                                      let paquetesIndividual = Math.floor(cantidad / multiple);

                                                      let totalPorPaquetes = paquetesIndividual * precioPorPaquete;
                                                      let totalPorRestante = restanteIndividual * precioBase;
                                                      let totalFinal = totalPorPaquetes + totalPorRestante;

                                                      precioAplicado = totalFinal / cantidad;
                                                  } else {

                                                     
                                                   

                                                      precioAplicado = precioPorPaquete / multiple;

                                                  }

                                                  }
                                                    setTimeout(() => this.actualizarProductos(), 0);
                                                }
                                              }
                                            }
                                            else if (escalonado) {
                                              const { typeList, Range } = escalonado;
                                              console.log('modelo escalonado', modelo);

                                              if (typeList === "1") {
                                                const rango = Range.find(r =>
                                                  cantidad >= r.limitLower && cantidad <= r.LimitUpper
                                                );
                                                if (rango) {
                                                  precioAplicado = parseFloat(rango.price);
                                                }

                                              } else if (typeList === "2") {

                                                const rango = Range.find(r => r.multiple !== 0);
                                                if (rango) {
                                                  const precioPorPaquete = parseFloat(rango.price);
                                                  const multiple = parseInt(rango.multiple);

                                                  const paquetes = Math.floor(totalCantidad / multiple);
                                                  const restante = totalCantidad % multiple;

                                                  const totalPorPaquetes = paquetes * precioPorPaquete;

                                                  let precioBase = parseFloat(precio);
                                                  
                                                  if (this.props.product?.priceList?.[0]) {
                                                    precioBase = parseFloat(this.props.product.priceList[0].price);
                                                  }

                                                  const totalPorRestante = restante * precioBase;

                                                  const totalFinal = totalPorPaquetes + totalPorRestante;

                                                  precioAplicado = totalFinal / totalCantidad;
                                                  setTimeout(() => this.actualizarProductos(), 0);

                                                }
                                              }
                                            }else{
                                              if (marcasCarrito.length > 0 ) {
                                                
                                                const cantidadesPorMarca = {};

                                                marcasCarrito.forEach(producto => {
                                                  const brandId = producto.brandId;
                                                  if(brandId === value.brandId  ){

                                                    const cantidadCarrito = parseInt(producto.cantidad || 1); 

                                                    if (!cantidadesPorMarca[brandId]) {
                                                      cantidadesPorMarca[brandId] = 0;
                                                    }

                                                    cantidadesTotalesCarrito += cantidadCarrito  ;

                                                  }else{
                                                    precioAplicado = precio;
                                                  }
                                                });
                                                
                                                cantidadesTotales = cantidadesTotalesCarrito + totalCantidad ;

                                                if(cantidadesTotales >= 12){

                                                  precioAplicado = precioMayoreo
                                                  this.actualizarProductosTallas();
                                                }else{
                                                  this.actualizarProductosTallas();
                                                }
                                              } else {
                                                  if(totalCantidad >= 12){
                                                    precioAplicado = precioMayoreo;
                                                    this.actualizarProductosTallas();
                                                  }else{
                                                    this.actualizarProductosTallas();
                                                  }
                                              }
                                            }

                                            const subtotal = cantidad * precioAplicado;

                                            this.colocarSubtotal(
                                              subtotal,
                                              value.color,
                                              value.talla,
                                              precioAplicado
                                            );

                                            this.setState({
                                              canSetItem: true
                                            });

                                            } else {
                                              this.colocarSubtotal(0, value.color, value.talla, 0);
                                              this.setState({
                                                canSetItem: false
                                              });
                                            }

                                          }}
                                        />
                                      ) : (
                                        <small>No disponible</small>
                                      )}
                                  </td>
                                    <td>
                                      <i
                                        style={{ color: '#333', fontWeight: '500' }}
                                      >
                                        $ {value.subtotal ? value.subtotal : 0}
                                      </i>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                    }
                    <br />
                    <p style={{ textAlign: 'center' }}>
                      <strong>
                        {this.props.colorSeleccionado.toUpperCase()}
                      </strong>
                    </p>
                    <br />
                  </Col>
                </Row>
                <Row>
                  {this.props.colorHidden ? (
                    <div />
                  ) : this.props.existenColores ? (
                    <Row>
                      <Col
                        xl={12}
                        l={12}
                        m={12}
                        s={12}
                        className={
                          this.props.colorId === 'SC'
                            ? 'general-margin hidden'
                            : 'general-margin'
                        }
                      >
                        <Col s ={12}>
                          <TextInput
                            s={12}
                            id={`input-colors`}
                            label="Color"
                            type="text"
                            value={this.state.currentColor}
                            min={1}
                            onChange={(event) => {
                              console.log(this.state.colores);
                              if ( event.target.value )
                              {
                                this.setState({
                                  currentColor: event.target.value,
                                  filtredColors: this.state.colores.filter((item) => item.id.toLowerCase().includes( event.target.value.toLowerCase() ) ||( item.name && item.name.toLowerCase().includes( event.target.value.toLowerCase() )) )
                                });
                              }
                              else
                              {
                                this.setState({
                                  currentColor: "",
                                  filtredColors: this.state.colores
                                });
                              }
                            }}
                            />
                        </Col>
                        <Col xl={12} l={12} m={12} s={12}>
                          {this.state.filtredColors.map((color, index) => {
                            return (
                              <Col
                                xl={2}
                                l={2}
                                m={3}
                                s={3}
                                onClick={async (event) => {

                                  this.setState({
                                    loadTallasInventory: true,
                                  });

                                  let productosTallas =
                                    await this.props.getTallasExistencias(
                                      color.id
                                    );
                                  this.colocarTallasPrecios(productosTallas);

                                  let colores = this.state.colores;
                                  let textColor = '';
                                  for (let i = 0; i < this.props.colores.length;i++) 
                                  {
                                    if (i === index) {
                                      colores[i].pulse = true;
                                    } else {
                                      colores[i].pulse = false;
                                    }
                                  }
                                  if (!color.id.includes('BLANCO')) {
                                    textColor = '#fff';
                                  } else {
                                    textColor = '#333';
                                  }

                                  // limpiando inputs
                                  let inputs =
                                    document.getElementsByClassName(
                                      'inputTalla'
                                    );
                                  for (let i = 0; i < inputs.length; i++) {
                                    inputs[i].value = null;
                                  }
                                  for (
                                    let i = 0;
                                    i < productosTallas.length;
                                    i++
                                  ) {
                                    productosTallas[i].subtotal = 0;
                                  }

                                  this.setState({
                                    colores: colores,
                                    colorBackTitulo: color.hex
                                      ? color.hex
                                      : '#c3c3c3',
                                    colorText: textColor,
                                    productosTallas: productosTallas,
                                    loadTallasInventory: false,
                                  });
                                }}
                                key={index}
                              >
                                <Row title={ ( color.name ? color.name + " " : "" ) + color.id}>
                                  <Col s={12}>
                                    <div className="center father">
                                    <button
                                    type="button"
                                    className={`btn-floating dimensions ${color.pulse ? 'pulse' : ''}`}
                                    title={color.hex}
                                     style={{ background: color.hex }}

                                     >
                                     {!isNaN(color.id) || color.id === 'SC'
                                      ? color.id
                                      : includesNumber(color.id)
                                      ? color.id
                                     : ''}
                                   </button>
                                    </div>
                                  </Col>
                                  <Col title={ ( color.name ? color.name + " " : "" ) + color.id} s={12} style={{textAlign:"center",fontSize:"12px", height: "2em", overflowY: "scroll", overflowX: "hidden", scrollbarWidth: "thin"}} >
                                    { ( color.name ? color.name + " " : "" ) + color.id}
                                  </Col>
                                </Row>
                              </Col>
                            );
                          })}
                        </Col>
                      </Col>
                    </Row>
                  ) : (
                    <Col xl={12} l={12} m={12} s={12}>
                      <br />
                      <h6>Sin Colores</h6>
                      <br />
                    </Col>
                  )}
                </Row>
              </Col>
            </Card>
            <strong
              className="masMarcas"
              style={{
                textAlign: 'left',
                cursor: 'pointer',
                fontSize: '15pt',
                marginBotton: '1%',
              }}
              onClick={() => {
                console.log('ONCLICK + MARCAS');
                this.setState({
                  isOpenMarcas: !this.state.isOpenMarcas,
                });
              }}
            >
              + Mas de esta marca
            </strong>
            {this.state.isOpenMarcas && (
              <MarcasRelacionadasView
                items={this.state.marcasRelacionadas}
                onClickElement={this.props.onClickElement}
                changeProductViewIds={this.props.changeProductViewIds}
              />
            )}
          </Col>
        </Col>
      </Row>
    );
  }
}

export { ProductView as default };
